module.exports = __webpack_public_path__ + "static/media/file-icon--white.886c7973.svg";